import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import SearchableContactList from 'components/Shared/Contacts/SearchableContactList';

import Drawer from 'components/Shared/Drawers';
import SimpleSkeleton from 'components/Shared/Contacts/SimpleSkeleton';
import Icon from 'components/Shared/Common/Icon';
import CategoryTitle from 'components/Shared/Layout/CategoryTitle';

const Search = ({
    intl,
    onClose,
}) => (
    <Drawer
        onClose={onClose}
        isOpen
        placement="left"
        title={(
            <CategoryTitle
                label={intl.formatMessage({ id: 'menuLeft.navigation.search' })}
                icon={<Icon size="xl" iconName="Search" />}
            />
        )}
    >
        <SearchableContactList
            pageSize={50}
            SkeletonComponent={SimpleSkeleton}
        />
    </Drawer>
);

Search.propTypes = {
    intl: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default injectIntl(Search);
